<template>

    <cms-modal title="Afhandelingstermijn actie wijzigen" @close="cancel">

        <cms-form submit-button="Opslaan" :submitting="submitting" @submit="submit" v-spinner="loading">

            <cms-form-input title="Afhandelingstermijn (dagen)" v-model.trim="actionDeadline" name="actionDeadline" :placeholder="deadlinePlaceholder"
                            v-validate="'numeric'" data-vv-as="Afhandelingstermijn" :error="error('actionDeadline')"></cms-form-input>

        </cms-form>

    </cms-modal>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import moment from 'moment'
    import gql from 'graphql-tag'

    import find from 'lodash/find'
    import without from 'lodash/without'
    import map from 'lodash/map'

    import LoggerMutations from 'app/mutations/LoggerMutations'

    @Component({

        name: 'action-deadline-modal',
        props: ['loggers']
    })
    export default class extends Vue
    {
        data(){

            return {

                loading: 0,
                submitted: false,
                submitting: false,

                actionDeadline: null
            }
        }

        get deadlinePlaceholder(){

            let defaultDeadline = di.get('config').defaultActionDeadline;

            if(this.loggers.length === 1 && this.loggers[0].activeAllocation && this.loggers[0].activeAllocation.project.actionDeadline){
                defaultDeadline = this.loggers[0].activeAllocation.project.actionDeadline
            }

            return defaultDeadline.toString();
        }

        mounted(){

            if(this.loggers.length === 1 && this.loggers[0].activeAllocation){
                this.actionDeadline = this.loggers[0].activeAllocation.actionDeadline;
            }
        }

        cancel(){

            this.dismiss();
        }

        error(field){

            return this.submitted ? this.errors.first(field) : null;
        }

        submit(){

            this.submitted = true;

            this.$validator.validateAll().then(success => {

                if (!success) {

                    this.$toast.error('Er zijn één of meerdere fouten');
                    return;
                }

                this.submitting = true;

                const deadline = this.actionDeadline !== null && this.actionDeadline !== '' ? parseInt(this.actionDeadline) : null;
                const loggerIds = map(this.loggers, 'id');

                LoggerMutations.updateActionDeadline(deadline, loggerIds).then(() => {

                    this.$emit('dismiss', true);

                }).catch(error => {

                    this.$logger.error('Error updating action deadline', error);
                    this.$toast.error('Kon de afhandelingstermijn niet opslaan');

                    this.submitting = false;
                })
            });
        }

        dismiss(result){

            this.$emit('dismiss', result);
        }
    }

</script>
